import { useCallback, useState } from 'react';

export const useMutation = (
  mutation: string,
): [(variables: any) => any, { loading: boolean; error: any }] => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mutate = useCallback(
    async (variables) => {
      setLoading(true);
      try {
        const body = JSON.stringify({
          operationName: null,
          variables,
          query: mutation,
        });
        const response = await fetch(
          `${process.env.GATSBY_PLATFORM_API_URL}/graphql/`,
          {
            headers: { 'content-type': `application/json` },
            method: `POST`,
            body,
          },
        );
        const result = await response.json();
        setLoading(false);
        return result.data;
      } catch (err) {
        setLoading(false);
        setError(err);
        return null;
      }
    },
    [mutation],
  );
  return [mutate, { loading, error }];
};
